<template>
	<!-- Main Sections -->
	<main class="main-wrapper">
		<!-- HERO BANNER START -->
		<section class="hero-banner py-24">
			<div class="container-fluid">
				<div class="row row-gap-3">
					<div class="col-xl-8 col-lg-12">
						<div class="banner-right">
							<div class="banner-content-right">
								<div class="text-box">
									<h6 class="color-ter mb-32 d-sm-block d-none">НОВОЕ ПОСТУПЛЕНИЕ</h6>
									<h2 class="white fw-600 mb-8">4K LCD<br><span class="color-ter">Quantum</span> Vision LCD</h2>
									<h6 class="white mb-32">Количество ограничено!</h6>
									<router-link :to="{path: '/catalog/18'}" class="cus-btn-3 sec">Купить</router-link>
								</div>
								<div class="image-area">
									<router-link :to="{path: '/catalog/18'}">
										<img src="/assets/media/banner/banner-sub-1.png" alt="">
									</router-link>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-4 col-lg-12">
						<div class="d-xl-block d-sm-flex gap-16">
							<div class="banner-right mb-16">
								<div class="banner-content-right v-2">
									<div class="text-box">
										<h5 class="fw-500 mb-16">
											<router-link :to="{path: '/catalog/3'}" class="white">Mobile <br> <span class="color-ter">Nexus&nbsp;</span>Mobile Pro 256GB</router-link>
										</h5>
										<p class="white fw-500">Количество ограничено!</p>
									</div>
									<div class="image-area">
										<router-link :to="{path: '/catalog/3'}">
											<img src="/assets/media/banner/banner-sub-2.png" alt="">
										</router-link>
									</div>
								</div>
							</div>
							<div class="banner-right">
								<div class="banner-content-right v-3">
									<div class="text-box">
										<h5 class="fw-500 mb-16">
											<router-link :to="{path: '/catalog/10'}" class="white">iPadMini <br> <span class="color-ter">10 Inch&nbsp;</span>iPad Mini Pro</router-link>
										</h5>
										<p class="white fw-500">Количество ограничено!</p>
									</div>
									<div class="image-area">
										<router-link :to="{path: '/catalog/10'}">
											<img src="/assets/media/banner/banner-sub-3.png" alt="">
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- HERO BANNER END -->
	
		<!-- Product Categories Start -->
		<div class="categories-sec py-24">
			<div class="container-fluid">
				<div class="row">
					<div class="categories-wrapper">
						<router-link :to="{path: '/catalog', query: {categories: appModel.getAllChildCategoryIds(cat.category_id)}}" class="category-block" v-for="cat in productsCategoriesForMain" :key="cat.id">
							<div class="image-box mb-12">
								<img :src="cat.icon" alt="">
							</div>
							<p class="fw-500 mb-4p">{{cat.name}}</p>
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<!-- Product Categories End -->
	
		<!-- Popular Product Start -->
		<section class="popular-product bg-lightest-gray pt-24 pb-40">
			<div class="container-fluid">
				<div class="top-bar mb-16">
					<h5>Популярные товары</h5>
					<router-link :to="{path: '/catalog'}" class="cus-btn-arrow">Каталог товаров
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
							<path
								d="M13.3545 14.7476C13.3545 11.7476 16.1545 7.74756 19.3545 7.74756M19.3545 7.74756C17.5212 7.74756 13.3545 6.74756 13.3545 0.747559M19.3545 7.74756H0.354492"
								stroke="#0C0C0D" stroke-width="2" />
						</svg>
					</router-link>
				</div>
				<div class="row row-gap-3">
					<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6" v-for="product in products" :key="product.id">
						<div class="featured-product-card bg-white br-10">
							<div class="image-box mb-16" style="height: 300px;">
								<!--<span class="sale-label">-12%</span>-->
								<router-link :to="{path: '/catalog/'+product.id}" class="h-100">
									<img :src="product.poster" class="product-image" alt="">
								</router-link>
								<div class="side-icons">
									<ul class="list-unstyled">
										<li>
											<a href="#" @click.prevent="appModel.toggleProductWishlist(product)" class="btn">
												<svg v-if="!appModel.hasProductInWishlist(product.id)" width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12.1,18.55L12,18.65L11.89,18.55C7.14,14.24 4,11.39 4,8.5C4,6.5 5.5,5 7.5,5C9.04,5 10.54,6 11.07,7.36H12.93C13.46,6 14.96,5 16.5,5C18.5,5 20,6.5 20,8.5C20,11.39 16.86,14.24 12.1,18.55M16.5,3C14.76,3 13.09,3.81 12,5.08C10.91,3.81 9.24,3 7.5,3C4.42,3 2,5.41 2,8.5C2,12.27 5.4,15.36 10.55,20.03L12,21.35L13.45,20.03C18.6,15.36 22,12.27 22,8.5C22,5.41 19.58,3 16.5,3Z" /></svg>
												<svg v-else width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z" /></svg>
											</a>
										</li>
										<!--
										<li>
											<a href="#" class="btn" data-bs-toggle="modal" data-bs-target="#productQuickView">
												<img src="/assets/media/icons/eye.png" alt="">
											</a>
										</li>
										-->
									</ul>
								</div>
							</div>
							<div class="product-desc">
								<h6 class="product-title mb-8">
									<router-link :to="{path: '/catalog/'+product.id}">{{product.name}}</router-link>
								</h6>
								<div class="rating-star mb-16 bg-white">
									<h6>
										<span class="text-decoration-line-through light-gray pe-2" v-if="product.oldPrice">{{number_format(product.oldPrice)}} тг</span>
										<span>{{number_format(product.price)}} тг</span>
									</h6>
								</div>
								<a href="#" @click.prevent="appModel.toggleProductBasket(product)" class="w-100" :class="{'cus-btn-2': !appModel.hasProductInBasket(product.id), 'cus-btn-3': appModel.hasProductInBasket(product.id)}">
									<span v-if="!appModel.hasProductInBasket(product.id)">В корзину</span>
									<span v-else>Убрать из корзины</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- Popular Product End -->
	
		<!-- Brand Slider Start -->
		<div class="brand-sec">
			<div class="container-fluid">
				<div class="row row-gap-3 py-4">
					<div class="col-6 col-sm-4 col-md-2" v-for="item in brands" :key="item.id">
						<router-link :to="{path: '/catalog'}" class="border-1 border rounded py-3 text-center w-100">
							<img :src="'assets/media/icons/logo-'+item.num+'.png'" alt="" />
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<!-- Brand Slider End -->
	
		<!-- Blog Section Start -->
		<section class="blog-section bg-lightest-gray py-40">
			<div class="container-fluid">
				<div class="top-bar mb-16">
					<h5>Последние новости</h5>
					<router-link :to="{path: '/news'}" class="cus-btn-arrow">Все новости
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
							<path
								d="M13.3545 14.7476C13.3545 11.7476 16.1545 7.74756 19.3545 7.74756M19.3545 7.74756C17.5212 7.74756 13.3545 6.74756 13.3545 0.747559M19.3545 7.74756H0.354492"
								stroke="#0C0C0D" stroke-width="2" />
						</svg>
					</router-link>
				</div>
				<div class="row row-gap-3">
					<div class="col-sm-6 col-md-4" v-for="item in news" :key="item.id">
						<router-link :to="{path: '/news/'+item.id}" class="card h-100">
							<img :src="'/'+item.poster" class="card-img-top" alt="">
							<div class="card-body">
								<p class="mb-16 fw-500 dark-black">{{formatDate(item.date, 'DD.MM.YYYY в HH:mm')}}</p>
								<h6 class="mb-16 fw-600">{{item.title}}</h6>
								<p class="light-gray mb-32">{{item.descriptions}}</p>
								<div class="cus-btn-arrow">Подробнее 
									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
										<path d="M13.3545 14.7476C13.3545 11.7476 16.1545 7.74756 19.3545 7.74756M19.3545 7.74756C17.5212 7.74756 13.3545 6.74756 13.3545 0.747559M19.3545 7.74756H0.354492"
											stroke="#0C0C0D" stroke-width="2" />
									</svg>
								</div>                
							</div>
						</router-link>
					</div>
				</div>
				
			</div>
		</section>
		<!-- Blog Section End -->
		 
		<benefits />
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Benefits from '@/components/Benefits';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech'});
	},
	data: () => ({
		productsCategoriesForMain: [],
		products: [],
		brands: [
			{id: 1, num: 1},
			{id: 2, num: 2},
			{id: 3, num: 3},
			{id: 4, num: 4},
			{id: 5, num: 5},
			{id: 6, num: 6},
		],
		news: [],
	}),
	methods: {
		formatDate: lib.formatDate,
		number_format(value){
			return lib.number_format(value, 0, '.', ' ');
		},
		
		async loadProductsCategoriesMainpage(){
			const ret = await this.appModel.doGetProductsCategoriesMainpage();
			if(ret.success){
				this.productsCategoriesForMain = ret.list;
			}
		},
		
		async loadProducts(){
			const params = {
				limit: 12,
				random: true,
			};
			const ret = await this.appModel.doGetProducts(params);
			if(ret.success){
				this.products = ret.list;
			}
		},
		
		async loadNews(){
			const params = {
				limit: 3,
			};
			const ret = await this.appModel.doGetNews(params);
			if(ret.success){
				this.news = ret.list;
			}
		},
	},
	mounted(){
		window.scrollTo(0, 0);
		
		this.loadProductsCategoriesMainpage();
		this.loadProducts();
		this.loadNews();
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		Benefits,
	},
};
</script>